var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 7.89,
    viewBox: "0 0 100 7.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#fff}\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    className: "cls-1",
    d: "M96.735 92.934H92.4V90.2h-2.2v7.4h2.2v-2.843h4.335V97.6h2.209v-7.4h-2.209z",
    transform: "translate(-90.2 -89.954)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    className: "cls-1",
    d: "M219.311 87.2a5.54 5.54 0 0 0-3.5 1.026 3.89 3.89 0 0 0 0 5.829 5.542 5.542 0 0 0 3.5 1.034c2.972 0 4.819-1.511 4.819-3.941s-1.847-3.948-4.819-3.948zm0 6.084c-1.617 0-2.578-.8-2.578-2.135s.961-2.135 2.578-2.135 2.578.8 2.578 2.135-.969 2.135-2.578 2.135z",
    transform: "translate(-204.295 -87.2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    className: "cls-1",
    d: "M351.8 90.2h-2.2v7.4h7.143v-1.784H351.8z",
    transform: "translate(-328.303 -89.954)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    className: "cls-1",
    d: "M457.911 87.2a5.54 5.54 0 0 0-3.5 1.026 3.89 3.89 0 0 0 0 5.829 5.542 5.542 0 0 0 3.5 1.034c2.972 0 4.819-1.511 4.819-3.941s-1.839-3.948-4.819-3.948zm0 6.084c-1.617 0-2.578-.8-2.578-2.135s.961-2.135 2.578-2.135 2.578.8 2.578 2.135-.96 2.135-2.578 2.135z",
    transform: "translate(-423.305 -87.2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    className: "cls-1",
    d: "M587 91.973h3.029V97.6h2.209v-5.627h3.046V90.2H587z",
    transform: "translate(-546.212 -89.954)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    className: "cls-1",
    d: "M722.847 92.737c0-1.568-1.289-2.537-3.366-2.537H714.3v7.406h2.192V95.29h2.11l1.938 2.315h2.57l-2.176-2.512a2.4 2.4 0 0 0 1.913-2.356zm-3.531.928h-2.841v-1.782h2.841c.879 0 1.289.279 1.289.887s-.41.895-1.289.895z",
    transform: "translate(-663.06 -89.954)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    className: "cls-1",
    d: "m842.226 90.2-3.826 7.406h2.315l.69-1.4h3.982l.69 1.4h2.348l-3.818-7.406zm-.049 4.409 1.223-2.488 1.215 2.488z",
    transform: "translate(-776.971 -89.954)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    className: "cls-1",
    d: "M979.2 90.2v7.4h2.2v-7.4z",
    transform: "translate(-906.212 -89.954)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    className: "cls-1",
    d: "m1009.7 90.2-3.7 3.695 3.7 3.7h2.783l-3.7-3.7 3.7-3.695z",
    transform: "translate(-930.811 -89.954)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    className: "cls-1",
    d: "m1098.84 93.895 1.56-1.552-2.151-2.143h-3.049l-3.7 3.695 3.7 3.7h3.111l-3.7-3.7 2.118-2.11z",
    transform: "translate(-1009.292 -89.954)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    className: "cls-1",
    d: "M1205.089 90.2h-3.112l3.7 3.695-2.11 2.118-2.118-2.118-1.552 1.56 2.143 2.143h3.046l3.7-3.7z",
    transform: "translate(-1108.792 -89.954)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.61ec18863157799bc8bc0d7dcfafb508.svg";
export { ForwardRef as ReactComponent };